/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
// eslint-disable-next-line no-unused-vars
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import LandingPage from 'pages/LandingPage';
import ProjectPage from 'pages/ProjectPage';
import ProjectDetailPage from 'pages/ProjectDetailPage';
import CareerPage from 'pages/CareerPage';
import DiscussProjectPage from 'pages/DiscussProjectPage';
import ApplyJobsPage from 'pages/ApplyJobsPage';
import NotFoundPage from 'pages/NotFoundPage';

import 'assets/css/styles.css';

function App() {
  return (
    <Switch>
      <Route exact path="/" component={LandingPage} />
      <Route exact path="/project" component={ProjectPage} />
      <Route exact path="/project/:id" component={ProjectDetailPage} />
      <Route exact path="/career" component={CareerPage} />
      <Route exact path="/discuss-project" component={DiscussProjectPage} />
      <Route exact path="/apply-jobs" component={ApplyJobsPage} />
      <Route path="" component={NotFoundPage} />
    </Switch>
  );
}

export default App;
